import { render, staticRenderFns } from "./SubscoreTable.vue?vue&type=template&id=d996b8be&scoped=true&"
import script from "./SubscoreTable.vue?vue&type=script&lang=js&"
export * from "./SubscoreTable.vue?vue&type=script&lang=js&"
import style0 from "./SubscoreTable.vue?vue&type=style&index=0&id=d996b8be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d996b8be",
  null
  
)

export default component.exports